/*
 * MycoTest — custom.js
 * Pipeline Theme customizations
 * Scroll animation system + page-load reveals
 */

(function() {

  // ============================================================
  // Animation CSS Injection
  // ============================================================
  var animStyle = document.createElement('style');
  animStyle.id = 'mt-animations';
  animStyle.textContent = [
    '[data-load]{opacity:0;transform:translateY(20px);transition:opacity 0.75s cubic-bezier(0.22,1,0.36,1),transform 0.75s cubic-bezier(0.22,1,0.36,1)}',
    '[data-load].is-loaded{opacity:1;transform:translateY(0)}',
    '[data-reveal]{opacity:0;transform:translateY(28px);transition:opacity 0.65s cubic-bezier(0.22,1,0.36,1),transform 0.65s cubic-bezier(0.22,1,0.36,1)}',
    '[data-reveal].is-visible{opacity:1;transform:translateY(0)}',
    '@media(prefers-reduced-motion:reduce){[data-load],[data-reveal]{transition:opacity 0.3s ease!important;transform:none!important}}'
  ].join('');
  document.head.appendChild(animStyle);

  document.addEventListener('DOMContentLoaded', function() {

    // --- Page-load reveals (hero above-fold content) ---
    document.querySelectorAll('[data-load]').forEach(function(el) {
      var delay = parseFloat(el.dataset.loadDelay || '0');
      setTimeout(function() { el.classList.add('is-loaded'); }, delay * 1000 + 80);
    });

    // --- Scroll reveals ---
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseFloat(el.dataset.revealDelay || '0');
          setTimeout(function() { el.classList.add('is-visible'); }, delay * 1000);
          observer.unobserve(el);
        });
      }, { threshold: 0.10, rootMargin: '0px 0px -32px 0px' });

      document.querySelectorAll('[data-reveal]').forEach(function(el) {
        observer.observe(el);
      });
    } else {
      document.querySelectorAll('[data-reveal]').forEach(function(el) {
        el.classList.add('is-visible');
      });
    }

  });

})();
